import { render, staticRenderFns } from "./AppNewIARC.vue?vue&type=template&id=60c20a94"
import script from "./AppNewIARC.vue?vue&type=script&lang=js"
export * from "./AppNewIARC.vue?vue&type=script&lang=js"
import style0 from "./AppNewIARC.vue?vue&type=style&index=0&id=60c20a94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports